import { Reveal } from "@/components/Reveal";

const REASONS = [
  { n: "01", title: "Rope Access", desc: "Técnicos certificados descendo por cordas: acesso total à fachada, inclusive onde andaime não chega." },
  { n: "02", title: "Sem andaimes", desc: "Nada de estrutura ocupando garagem, jardim e calçada por meses. Montagem e desmontagem no mesmo dia." },
  { n: "03", title: "Menos transtorno", desc: "Moradores seguem a rotina: sem barulho de montagem, sem ferro na janela, sem obra eterna." },
  { n: "04", title: "Prazo curto", desc: "Equipe enxuta e móvel. O cronograma é medido em dias por face do prédio, não em meses." },
];

export const WhyKrono = () => (
  <section data-testid="why-krono-section" className="border-y border-white/10 bg-[#0A0A0A]">
    <div className="mx-auto max-w-7xl px-6 py-24 md:py-32">
      <Reveal>
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-krono">[ Por que KRONO ]</p>
        <h2 className="max-w-2xl font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
          O andaime ficou no passado.
        </h2>
      </Reveal>
      <div className="mt-16 grid border-l border-t border-white/10 md:grid-cols-2">
        {REASONS.map((r, i) => (
          <Reveal key={r.n} delay={i * 0.08} className="border-b border-r border-white/10">
            <div
              data-testid={`why-card-${r.n}`}
              className="group h-full p-8 transition-colors hover:bg-[#111] md:p-12"
            >
              <span className="font-mono text-sm text-krono">[ {r.n} ]</span>
              <h3 className="mt-4 font-display text-xl font-semibold transition-colors group-hover:text-krono sm:text-2xl">
                {r.title}
              </h3>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-white/60">{r.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
